import { useEffect, useRef } from "react";

// Runs fn now, every intervalMs while visible, and on return to the app. No overlaps; quiet retry on failure.
export function usePolling(fn, deps, intervalMs = 15000) {
  const fnRef = useRef(fn);
  fnRef.current = fn;
  useEffect(() => {
    let inFlight = false;
    let stopped = false;
    let retryTimer = null;
    const run = async () => {
      if (stopped || inFlight || document.hidden) return;
      inFlight = true;
      try {
        await fnRef.current();
      } catch {
        clearTimeout(retryTimer);
        retryTimer = setTimeout(run, 4000);
      } finally {
        inFlight = false;
      }
    };
    run();
    const timer = intervalMs ? setInterval(run, intervalMs) : null;
    const onVisible = () => { if (!document.hidden) run(); };
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("online", run);
    return () => {
      stopped = true;
      clearInterval(timer);
      clearTimeout(retryTimer);
      document.removeEventListener("visibilitychange", onVisible);
      window.removeEventListener("online", run);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
